// extracted by mini-css-extract-plugin
export default {"propertyDescription":"property_info_section_propertyDescription__wDg7D","propertyTitleSection":"property_info_section_propertyTitleSection__cc14H"};